import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyModule } from 'survey-angular-ui';
import { SurveyCreatorModule } from 'survey-creator-angular';
import { SurveyCreatorModel } from 'survey-creator-core';
import { Serializer, StylesManager } from 'survey-core';
import { SharedModule } from '../../shared/shared.module';

StylesManager.applyTheme('modern');
const creatorOptions = {
  showLogicTab: false,
  showState: true,
};
const creatorOptionsForPreview = {
  showLogicTab: false, 
  showTranslationTab: false,
  showEmbedTab: false, 
  showSurveyTab: false, 
  showJSONEditorTab: false, 
  showTestSurveyTab: false, 
  showSettingsTab: false, 
  showDesignerTab: false,
  showDefaultLanguageInPreviewTab: false,
  showErrorOnFailedSave: false,
  showHeaderInEmptySurvey: false,
  showInvisibleElementsInPreviewTab: false,
  showObjectTitles: false,
  showPagesInPreviewTab: false,
  showSimulatorInPreviewTab: false,
  showSurveyTitle: false,
  showThemeTab: false,
  showTitlesInExpressions: false,
  showPreviewTab: true,
};
Serializer.removeProperty('survey', 'logoPosition');
@Component({
  selector: 'app-quiz-creator',
  standalone: true,
  imports: [CommonModule, SurveyModule, SurveyCreatorModule, SharedModule],
  templateUrl: './quiz-creator.component.html',
  styleUrls: ['./quiz-creator.component.scss'],
})
export class QuizCreatorComponent {
  @Input() quizText: string | null = null;
  @Input() isShowPreviewOnly: boolean = false;
  surveyCreatorModel!: SurveyCreatorModel;
  creator!: SurveyCreatorModel;
  constructor() {}

  ngOnInit() {
    this.creator = new SurveyCreatorModel(
      this.isShowPreviewOnly ? creatorOptionsForPreview : creatorOptions
    );
    this.creator.text =
      this.quizText === null ? '{}' : JSON.parse(this.quizText);
    if (this.isShowPreviewOnly) {
      setTimeout(() => {
        this.creator.showPreview(); 
      }, 100);
    }
    this.surveyCreatorModel = this.creator;
  }

  updateCreatorText = (quizText: string | null) => {
    this.creator.text = quizText === null ? '{}' : JSON.parse(quizText);
  };

getQuizDetails = (): string => {
  const editorModel: any = (this.creator as any).getPlugin?.('editor')?.model;

  if (this.creator?.activeTab === 'editor' && editorModel?.text) {
      return JSON.stringify(editorModel.text);
  }

  return JSON.stringify(this.creator.text);
};
}
